import { Col, Row, Table } from 'reactstrap';
import { ContentBlock } from '../../Shared/Content/ContentBlock';
import { ContentHeading } from '../../Shared/Content/ContentHeading';
import { ContentBody } from '../../Shared/Content/ContentBody';
import { clientConfig } from '../../../utilities/configService';
import parse from 'html-react-parser';

export const Installation = () => {
    return (
        <div id="installation">
            <ContentBlock className="evSupplyEquipmentSection">
                <ContentHeading title="Electric Vehicle Supply Equipment Installation" />
                <ContentBody>
                    <div className="heading5">
                        Every EV needs charging infrastructure to keep it fully charged and on the road. This means EVSE also needs to be installed properly while abiding by codes and requirements to ensure its safe operation.
                    </div>
                    <Row className="tableBlock">
                        <Col>
                            <div className="subContent">
                                <h4 className="css_heading bold">Installation</h4>
                                <div className="body indent">
                                    <p>
                                        <ul>
                                            <li>The NEC and most state codes require that all components (materials, devices, fittings, etc.) be listed or safety-labeled.</li>
                                            <li>EVSE installations require building permits. Permit costs vary by municipality, and a service panel upgrade will add to the cost. Installations should be done by a qualified electrician.</li>
                                            <li>The installation contractor is responsible for ensuring that their EVSE installations comply with all federal, state, local, and municipal codes.</li>
                                        </ul>
                                    </p>
                                </div>

                                <h4 className="css_heading bold">Siting</h4>
                                <div className="body indent">
                                    <p>
                                        <strong>Mounting:</strong> The physical space available for EV chargers often determines the type of mounting.
                                        <ul>
                                            <li>Ceiling-mounted chargers are often used for electric bus charging at depots.</li>
                                            <li>Wall- or pedestal-mounted EVSE can have different operation and maintenance requirements.</li>
                                        </ul>
                                    </p>
                                </div>
                                <div className="body indent">
                                    <p>
                                        <strong>Location:</strong> EVSE installed outdoors requires more maintenance and more inspections for wear and tear.
                                        <ul>
                                            <li>Reinforced sockets for ultimate flexibility and durability are recommended.</li>
                                        </ul>
                                    </p>
                                </div>

                                <h4 className="css_heading bold">Your EVSE Installation Checklist</h4>
                                <div className="body indent">
                                    {clientConfig?.CONTENT.EV_INSTALLATION_CHECKLIST_BODY ? parse(clientConfig.CONTENT.EV_INSTALLATION_CHECKLIST_BODY as string) : null}
                                    {clientConfig?.CONTENT.EV_INSTALLATION_CHECKLIST_LINK ? parse(clientConfig.CONTENT.EV_INSTALLATION_CHECKLIST_LINK as string) : null}
                                </div>

                                <h4 className="css_heading bold">Additional Considerations</h4>
                                <div className="body indent">
                                    <p><strong>Access:</strong> Chargers should be Americans with Disabilities Act (ADA) compliant. ADA-compliant parking spaces with curb cutouts and accessible connector heights are recommended. For more information, see the Alternative Fuel Data Center.</p>
                                    <p><strong>Project Planning and Scalability:</strong> Charging solutions should be planned to avoid both under- and over-sizing electrical capacity. Future-proofing charging systems and planning wiring and infrastructure avoids additional retrofitting costs.</p>
                                    <p><strong>Security:</strong> Consider proper lighting and strategies (e.g., motion detectors) to minimize vandalism. For more information, see the Alternative Fuels Data Center Signage Guidelines.</p>
                                    <p><strong>Power Outages:</strong> While the current battery storage capacities of most EVs are large enough to allow going without charging for one day or two, supplying off-grid power through a generator or additional energy storage systems is the most effective resilience strategy for fleet operators.</p>
                                    <p><strong>Efficiency:</strong> Choosing a charger that has earned the U.S. Environmental Protection Agency ENERGY STAR&reg; label means you're getting certified energy savings, safety, and smart technology. ENERGY STAR&reg; certified Level 2 chargers provide all the same functionality as standard products but use 40% less energy in standby mode.</p>
                                </div>
                            </div>
                        </Col>
                    </Row>

                </ContentBody>
            </ContentBlock>
        </div>
    );

};
